import { GET_LICENSE_SUCCESS } from "../actions/license";

export function license(state = [], action) {
    switch (action.type) {
        case GET_LICENSE_SUCCESS:
            return action.license;
    
        default:
            return state;
    }
}